/* As designed */
export const HEADER_HEIGHT = 48;
